import React from 'react';

/**
 * ArrowRightIcon Component
 *
 * This component renders an SVG icon representing a right-pointing arrow.
 * It accepts an optional 'className' prop to allow custom styling.
 *
 * Props:
 * - className: string (optional) - Additional CSS classes for styling the icon.
 */
const ArrowRightIcon = ({ className = '' }) => {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      stroke="#D3D6DC"
      strokeWidth="3"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <polyline points="44 40 52 32 44 24" />
      <line x1="52" y1="32" x2="13" y2="32" />
    </svg>
  );
};

export default ArrowRightIcon;
